import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import { Box, FormControl, Grid, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiCall } from 'use-api-call';
import { DevLabelEnum } from '../../../../configs/language/developersTranslations';
import useBoolean from '../../../../hooks/useBoolean';
import CredentialSvc from '../../../../services/credentials/CredentialSvc';
import { useAppDispatch } from '../../../../store';
import {
  CreateCredentialModalProps,
  ICredentialRequest,
} from '../../Credentials.interface';
import { fetchCredentials } from '../../store';

const CreateCredentialModal = ({
  open,
  onClose,
}: CreateCredentialModalProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [alias, setAlias] = useState('');
  const [isModalKeys, { setTrue: showModalKeys }] = useBoolean(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {
    data,
    error,
    invoke: createCredential,
  } = useApiCall((request: ICredentialRequest) =>
    CredentialSvc.createCredential(request)
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAlias(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    createCredential({ alias });
  };

  const handleClose = () => {
    dispatch(fetchCredentials());
    onClose();
  };

  useEffect(() => {
    if (data) showModalKeys();
  }, [data, showModalKeys]);

  useEffect(() => {
    if (error && axios.isAxiosError(error))
      setErrorMessage(error.response?.data.detail);
  }, [error]);

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle showCloseButton onClick={handleClose}>
          <Box>
            <Typography variant="h6">
              {t(DevLabelEnum.DEV_CREATE_TITLE)}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <TextField
                  label={t(DevLabelEnum.DEV_ALIAS)}
                  value={alias}
                  onChange={handleChange}
                  required
                />
                {errorMessage && (
                  <p className="text-orange-600 text-xs mt-1">{errorMessage}</p>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              className="flex !justify-around !mt-5"
              style={{ gap: '20px' }}
            >
              <Button
                appearance="secondary"
                size="large"
                className="mt-4"
                onClick={handleClose}
              >
                {t('back')}
              </Button>
              <Button
                appearance="primary"
                size="large"
                className="mt-4"
                type="submit"
              >
                {t(DevLabelEnum.DEV_BTN_CREATE)}
              </Button>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      {isModalKeys && (
        <Dialog
          open={isModalKeys}
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle showCloseButton onClick={handleClose}>
            <Box>
              <h3>{t(DevLabelEnum.DEV_CREATE_TITLE)}</h3>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              rowSpacing={2}
              columnSpacing={{ xs: 2, sm: 2, md: 3 }}
            >
              <Grid item xs={12}>
                <Box style={{ fontSize: '15px' }}>
                  {t(DevLabelEnum.DEV_SUBTITLE_THREE)}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={t(DevLabelEnum.DEV_KEY_ID)}
                    value={data.client_id}
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={t(DevLabelEnum.DEV_KEY_SECRET)}
                    value={data.secret_key}
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              className="flex !justify-around !mt-5"
              style={{ gap: '20px' }}
            >
              <Button
                appearance="secondary"
                size="large"
                className="mt-4"
                onClick={handleClose}
              >
                {t('back')}
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CreateCredentialModal;
